import Backdrop from "components/global/Backdrop";
import styled, { keyframes } from "styled-components";

export const PageWrapper = styled.div`
  padding: 24px;
  background: #f8f8f8;

  .card {
    &:hover {
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1),
        0px 25px 35px 0px rgba(188, 169, 169, 0.1);
    }
  }
`;

export const Intro = styled.div`
  padding: 24px 0;

  display: flex;
  align-items: flex-start;
  overflow: auto;
  gap: 56px;

  .intro_card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .page-header {
    font-size: 32px;
    font-weight: 700;
    line-height: 40px;
  }

  .description {
    font-size: 14px;
    line-height: 20px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;

    .intro_card {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
    }
  }
`;

export const CardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;

  .intro_video_btn {
    background-color: var(--secondary);
    color: #fff;
    font-size: 14px;
    font-weight: 450;
    padding: 14px;
    height: 46px;
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    transition: var(--transition_default);

    &:hover {
      background-color: var(--primary_light);
    }
  }

  .card {
    border-radius: 8px;
    padding: 16px;
    background-color: #fff;
    border: 1px solid var(--grey_10);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;

    .content {
      gap: 4px;
    }

    .title {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: var(--grey_1);
    }

    .description {
      font-size: 14px;
      font-weight: 450;
      line-height: 20px;
      color: var(--grey_6);
    }

    button {
      background-color: var(--secondary);
      color: #fff;
      font-size: 14px;
      font-weight: 450;
      padding: 8px 14px;
      display: flex;
      gap: 4px;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      transition: var(--transition_default);
      justify-self: flex-end;

      &:hover {
        background-color: var(--primary_light);
      }
    }
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));

    .card {
      min-width: 100%;
      width: 100%;
      max-width: 100%;
    }
  }
`;

export const GettingStarted = styled.div`
  .suggestion-row {
    display: flex;
    gap: 24px;
    align-items: flex-start;
  }

  @media screen and (max-width: 768px) {
    .suggestion-row {
      flex-direction: column;
    }
  }
`;

export const VideoWrapper = styled(Backdrop)`
  padding: 0;

  .close_btn {
    background-color: #fff;
    position: absolute;
    top: -30px;
    right: -30px;
    width: 36px;
    height: 36px;
    z-index: 10;
    border-radius: 100%;
  }

  .modal {
    position: relative;
    background-color: #fff;
    height: 80vh;
    border-radius: 8px;
    width: 100%;
  }

  .intro_vid {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 8px;
  }

  iframe {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }

  @media screen and (max-width: 768px) {
    .modal {
      height: 90%;
      width: calc(100% - 24px);
    }

    .close_btn {
      top: -10px;
      right: -10px;
    }
  }
`;

export const NewCard = styled.div`
  min-width: 240px;
  width: 240px;
  max-width: 240px;
  border-radius: 8px;
  padding: 16px;
  background-color: #fff;
  border: 1px solid var(--grey_10);
  gap: 8px;
  cursor: pointer;

  .content {
    gap: 4px;
  }

  .title {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: var(--grey_1);
  }

  .description {
    font-size: 14px;
    font-weight: 450;
    line-height: 20px;
    color: var(--grey_6);
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) => columns || "1fr"};
  grid-template-rows: ${({ rows }) => rows || "auto"};
  gap: ${({ gap }) => gap || "16px"};
  padding: ${({ padding }) => padding || "0"};
  width: 100%;
  height: ${({ height }) => height || "auto"};
  margin-top: ${({ mt }) => mt || "0"};

  @media screen and (max-width: 768px) {
    grid-template-columns: ${({ mbColumn }) => mbColumn || "1fr"};
  }
`;

export const GridItem = styled.div`
  background-color: ${({ bgColor }) => bgColor || "transparent"};
  border: ${({ border }) => border || "none"};
  border-radius: ${({ borderRadius }) => borderRadius || "8px"};
  padding: ${({ padding }) => padding || "0"};
  box-shadow: ${({ shadow }) => shadow || "none"};
  text-align: ${({ textAlign }) => textAlign || "left"};
  grid-column: span ${({ colSpan }) => colSpan || "1"};
`;

const blink = keyframes`
  0% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.7;
  }
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  padding: 24px;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05),
    0px 25px 35px 0px rgba(0, 0, 0, 0.03);
  gap: 24px;

  .skeletonHeader {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .skeletonText {
      width: 180px;
      height: 20px;
      background: #e0e0e0;
      border-radius: 4px;
      animation: ${blink} 1.5s infinite ease-in-out;
    }

    .skeletonButton {
      width: 150px;
      height: 36px;
      background: #e0e0e0;
      border-radius: 8px;
      animation: ${blink} 1.5s infinite ease-in-out;
    }
  }

  .skeletonChannelList {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    .skeletonCard {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px;
      border-radius: 12px;
      background: #f8f8f8;
      border: 1px solid #e2e2ea;
      gap: 16px;

      .skeletonImage {
        width: 24px;
        height: 24px;
        background: #e0e0e0;
        border-radius: 50%;
        animation: ${blink} 1.5s infinite ease-in-out;
      }

      .skeletonLine {
        flex: 1;
        height: 16px;
        background: #e0e0e0;
        border-radius: 4px;
        width: 16px;
        animation: ${blink} 1.5s infinite ease-in-out;
      }

      .skeletonIcon {
        width: 16px;
        height: 16px;
        background: #e0e0e0;
        border-radius: 50%;
        animation: ${blink} 1.5s infinite ease-in-out;
      }
    }
  }

  @media screen and (max-width: 1100px) {
    flex-direction: column;

    .skeletonChannelList {
      width: 100%;
      grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));

      .skeletonCard {
        width: 100%;

        .skeletonLine {
          display: none;
        }
      }
    }
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;

    th {
      padding: 8px 24px;
      height: 40px;
      color: #7e7e8f;
      text-align: left;
    }

    td {
      padding: 24px;
      color: #545454;
    }

    th {
      font-size: 12px;
      font-weight: bold;
      border-bottom: 1px solid #e2e2ea;
    }

    td {
      font-size: 14px;
    }

    tr:not(:last-child) {
      border-bottom: 1px solid #e2e2ea;
    }
  }

  @media (max-width: 768px) {
    th,
    td {
      padding: 8px;
    }
  }
`;

export const SkeletonRow = styled.tr`
  td {
    background: #e2e2ea;
    height: 40px;
    border-radius: 4px;
    animation: skeleton-loading 1.5s infinite ease-in-out;
    padding: 12px 16px;
    margin: 8px 0;
    border-bottom: 8px solid white;

    &:nth-child(1) {
      width: 30%;
    }
    &:nth-child(2) {
      width: 15%;
    }
    &:nth-child(3) {
      width: 15%;
    }
    &:nth-child(4) {
      width: 15%;
    }
    &:nth-child(5) {
      width: 12%;
    }
    &:nth-child(6) {
      width: 13%;
    }
  }

  & + & {
    margin-top: 16px;
  }

  @keyframes skeleton-loading {
    0% {
      background-color: #f0f0f0;
    }
    50% {
      background-color: #e2e2ea;
    }
    100% {
      background-color: #f0f0f0;
    }
  }
`;
